"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventPayload = exports.checkParamType = exports.checkIfDefined = exports.checkParamDefined = exports.serializeUserSearchParams = void 0;
var RequestEvent_1 = require("./RequestEvent");
var convertToQueryFriendlyFormat = function (property) {
    if (property instanceof Date) {
        return property.getTime();
    }
    if (typeof property === 'object') {
        return JSON.stringify(property);
    }
    return property;
};
var serializeUserSearchParams = function (user, queryParams) {
    for (var key in user) {
        var userProperty = convertToQueryFriendlyFormat(user[key]);
        if (userProperty !== null && userProperty !== undefined) {
            queryParams.append(key, userProperty);
        }
    }
};
exports.serializeUserSearchParams = serializeUserSearchParams;
var checkParamDefined = function (name, param) {
    if (!(0, exports.checkIfDefined)(param)) {
        throw new Error("Missing parameter: ".concat(name));
    }
};
exports.checkParamDefined = checkParamDefined;
var checkIfDefined = function (variable) {
    if (variable === undefined || variable === null) {
        return false;
    }
    return true;
};
exports.checkIfDefined = checkIfDefined;
var checkParamType = function (name, param, type) {
    if (!param) {
        throw new Error("Missing parameter: ".concat(name));
    }
    if (typeof param !== type) {
        throw new Error("".concat(name, " is not of type ").concat(type));
    }
};
exports.checkParamType = checkParamType;
function generateEventPayload(config, user, events) {
    return {
        events: events.map(function (event) {
            return new RequestEvent_1.DVCRequestEvent(event, user.user_id, config === null || config === void 0 ? void 0 : config.featureVariationMap);
        }),
        user: user,
    };
}
exports.generateEventPayload = generateEventPayload;
exports.default = {
    serializeUserSearchParams: exports.serializeUserSearchParams,
    checkParamDefined: exports.checkParamDefined,
    generateEventPayload: generateEventPayload,
};
//# sourceMappingURL=utils.js.map